import { Avatar, Box, Divider, Flex, Heading, Link, SimpleGrid, Text } from "@chakra-ui/react";
import LandingContent from "../../components/landing-content";

function ContactPerson(props: { name: string; role: string; email: string; img?: string }) {
  return (
    <Flex mt="2">
      <Avatar bgColor="brand.gray.300" color="black" size="lg" name={props.name} src={props.img} />
      <Box ml={3}>
        <Text fontWeight="bold">{props.name}</Text>
        <Text fontSize="sm">{props.role}</Text>
        <Link fontSize="sm" textDecor={"underline"} href={`mailto:${props.email}`}>
          Contact
        </Link>
      </Box>
    </Flex>
  );
}

export default function About() {
  return (
    <>
      {/* <Box
        backgroundColor="#eee"
        bgImage={`url('/affiliate-program.jpeg')`}
        bgPosition="center"
        bgSize="cover"
        bgRepeat="no-repeat"
        w={"100%"}
        maxW="1072px"
        my={5}
        marginLeft="auto"
        marginRight="auto"
        height={{ base: "200px", md: "350px" }}
      ></Box> */}
      <LandingContent>
        <Heading as="h1" mb={3} fontSize={"3xl"}>
          About Talkio
        </Heading>

        <Text mb={3}>
          {`Welcome to Talkio AI! We believe learning a new language should be
          fun, interactive, and personalized. That's why we've developed a
          unique platform where you can practice your language skills with our
          AI tutors in a safe and supportive environment.`}
        </Text>

        <Heading mt={8} as="h3" fontSize="xl" lineHeight={2}>
          Contact & Support
        </Heading>

        <Text mb={10}>
          If you have any questions or feedback, do not hesitate to reach out on
          <Link ml={1} textDecor={"underline"} href="mailto:hello@talkio.ai">
            hello@talkio.ai
          </Link>
        </Text>

        <Divider />

        <Heading mt={10} as="h3" fontSize="xl" lineHeight={2} mb="2">
          Business Inquiries
        </Heading>

        <SimpleGrid columns={{ base: 1, sm: 2, md: 3 }} spacing={5}>
          <ContactPerson
            name="Theis Frøhlich"
            role="Founder"
            email="theis@talkio.ai"
            img="/images/about/theis.jpeg"
          />

          <ContactPerson
            name="Jeppe Knappe"
            role="Managing Director"
            email="jeppe@talkio.ai"
            img="/images/about/jeppe.png"
          />

          <ContactPerson
            name="Grzegorz Markowski"
            role="Head of Global Digital"
            email="greg@talkio.ai"
            img="/images/about/greg.jpg"
          />

          <ContactPerson
            name="Dongpil Lim"
            role="Regional Sales, South Korea"
            email="dongpil.lim@thermp.co.kr"
            img="/images/about/dongpil.jpg"
          />

          <ContactPerson
            name="Aggelopoulos Aggelos"
            role="Regional Sales, Greece"
            email="contact@germanofcourse.com"
            img="/images/about/aggelos.png"
          />

          <ContactPerson name="John Guo" role="Regional Sales, China" email="cn@talkio.ai" />
        </SimpleGrid>

        <Divider mt="12" mb="6" />

        <Heading mb="2" as="h3" fontSize="xl" lineHeight={2}>
          Company Information
        </Heading>

        <Text mb={1}>Aidia ApS</Text>
        <Text mb={1}>Pærevangen 15, 1. mf.</Text>
        <Text mb={1}>2765 Smørum</Text>
        <Text mb={8}>Denmark</Text>
      </LandingContent>
    </>
  );
}
